import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, Text, Divider, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { kpiSections, totalNote } from "./kpiData";
import Layout from "./Layout";

const ColHead = () => (
  <Tr>
    <Th width="80px">№</Th>
    <Th>ПАРАМЕТРЛАР</Th>
    <Th>Амалга ошириш механизми</Th>
    <Th width="140px">Мезон (энг юқори балл)</Th>
    <Th>Асословчи ахборот</Th>
  </Tr>
);

const EvidenceCell = ({ list = [] }) => (
  <Td>
    <Box as="ol" pl={5} style={{ listStyle: "decimal" }}>
      {list.map((e, i) => (
        <li key={i}><Text>{e}</Text></li>
      ))}
    </Box>
  </Td>
);

const KpiCriteria = () => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <Box p={4}>
        <Heading size="md" textAlign="center" mb={4}>
          ПРОФЕССОР-ЎҚИТУВЧИЛАРИ ФАОЛИЯТИНИНГ ИШ САМАРАДОРЛИГИНИ БАҲОЛАШ (KPI) МЕЗОНЛАРИ
        </Heading>
        {kpiSections.map(section => (
          <Box key={section.key} mb={10}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Heading size="sm">{section.title}</Heading>
              <Button
                size="sm"
                colorScheme="blue"
                variant="outline"
                onClick={() => navigate(`/teachers-by-category/${section.key}`)}
              >
                Reytingni ko'rish
              </Button>
            </Box>
            <Table size="sm" variant="simple">
              <Thead><ColHead /></Thead>
              <Tbody>
                {section.items.map(item => (
                  <Tr key={item.no} verticalAlign="top">
                    <Td>{item.no}</Td>
                    <Td><Text whiteSpace="pre-wrap">{item.parameter}</Text></Td>
                    <Td><Text whiteSpace="pre-wrap">{item.mechanism}</Text></Td>
                    <Td>{item.maxBall}</Td>
                    <EvidenceCell list={item.evidence} />
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Divider mt={4} />
          </Box>
        ))}
        <Text mt={4} fontWeight="semibold">{totalNote}</Text>
      </Box>
    </Layout>
  );
};

export default KpiCriteria; 